import { Currency } from '@core/constants/data-types.constants';

export interface CurrencyAmount {
  currency: Currency;
  amount: number;
}

export const DummyCurrencyAmount: CurrencyAmount = {
  currency: 'EUR',
  amount: 0
};

export function sumCurrencyAmount(ca1 : CurrencyAmount, ca2 : CurrencyAmount) : CurrencyAmount {
  return {
    amount: ca1.amount + ca2.amount,
    currency: "EUR"
  }
}

export function substractCurrencyAmount(ca1 : CurrencyAmount, ca2 : CurrencyAmount) : CurrencyAmount {
  return {
    amount: ca1.amount - ca2.amount,
    currency: "EUR"
  }
}

export function savingFeeCurrencyAmount(ca1 : CurrencyAmount, goalAge: number) : CurrencyAmount {
  return {
    amount: ca1.amount / goalAge,
    currency: "EUR"
  }
}